import moment from 'moment';

export type TimeRange = {
    title: string;
    startTime: moment.Moment;
    endTime: moment.Moment;
};

export type AppointmentSlot = {
    date: moment.Moment;
    timeRange: TimeRange;
};

export class AppointmentModel {
    public constructor(public slotIntervals: OdataSlotIntervalModel[] = []) {}

    public static fromODataAppointmentSlots(data: OdataAppointmentSlotResponseModel): AppointmentModel {
        return new AppointmentModel(data.SlotIntervalSet.results);
    }
}

export interface OdataSlotIntervalModel {
    __metadata: {
        id: string;
        uri: string;
        type: string;
    };
    StartDate: string;
    StartTime: string;
    FinishDate: string;
    FinishTime: string;
    Grade: string;
}

export interface OdataAppointmentSlotResponseModel {
    __metadata: {
        id: string;
        uri: string;
        type: string;
    };
    NotificationNo: string;
    TaskNumber: string;
    Duration: string;
    StartDate: string;
    FinishDate: string;
    UserName: string;
    SlotIntervalSet: {
        results: OdataSlotIntervalModel[];
    };
}

export type ODataAppointmentSlotsPayload = {
    NotificationNo: string;
    TaskNumber: string;
    Duration: string;
    StartDate: string;
    FinishDate: string;
    UserName: string;
    SlotIntervalSet: OdataSlotIntervalModel[];
};
